// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__hQi0f","loading":"style_loading__36OiF"};